<template>
    <section class="banner-carousel">
        <slides v-if="mobileBanners.length"
            :slides="mobileBanners"
            class="slides--mobile"
        />

        <slides v-if="desktopBanners.length"
            :slides="desktopBanners"
            class="slides--desktop"
        />
    </section>
</template>

<script>
// Components
import slides from './slides.vue';

// Store
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'banner-carousel',
    components: {
        slides,
    },
    computed: {
        ...mapGetters(['banners']),

        bannerImages() {
            return this.banners
                .filter((image) => image.image.large.url)
                .map((image) => ({
                    mobileImgUrl: this.getImageUrl(image.image),
                    desktopImgUrl: this.getImageUrl(image.desktop_image),
                    link: image.processedLink,
                    button: {
                        isRightAligned: image.button_alignment === 'right',
                        background: image.button_background_color,
                        color: image.button_text_color,
                        text: image.button_text,
                    },
                    headings: {
                        isRightAligned: image.headings_alignment === 'right',
                        primary: {
                            text: image.primary_heading,
                            color: image.primary_heading_color,
                        },
                        secondary: {
                            text: image.secondary_heading,
                            color: image.secondary_heading_color,
                        },
                    },
                }));
        },
        mobileBanners() {
            return this.bannerImages
                .filter((banner) => banner.mobileImgUrl)
                .map((banner) => ({
                    ...banner,
                    imageUrl: banner.mobileImgUrl,
                }));
        },
        desktopBanners() {
            return this.bannerImages
                .filter((banner) => banner.desktopImgUrl)
                .map((banner) => ({
                    ...banner,
                    imageUrl: banner.desktopImgUrl,
                }));
        },
    },
    methods: {
        getImageUrl(image) {
            return image ? image.large.url : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.slides {
    &--desktop {
        display: none;
    }

    @include min-width(md) {
        &--mobile {
            display: none;
        }

        &--desktop {
            display: block;
        }
    }
}
</style>